import { Box } from '@primer/react'
import HeaderStyle from "./Header.module.scss"
import { useNavigate } from 'react-router-dom'
const logoUrl = "https://deski-app.vercel.app/deski-logo.svg"
function Header() {

      
       const navigate = useNavigate()
       return (

              <Box position="fixed"
                     width={'100%'}
                     height={48}
                     background="#FFFFFF"
                     borderColor="border.default"
                     borderWidth={1}
                     borderStyle="solid"
                     p={0}
                     zIndex={1}
              >

                     <Box sx={{
                            display: 'flex',
                            border: 'none',
                            position: 'absolute',
                            left: '50px',
                            right: '80px',
                            top: '0px',
                            bottom: '0px',
                            margin: 'auto',
                            height: 'fit-content'

                     }}
                     >
                      <img  className={HeaderStyle.logoStyle} src={logoUrl} onClick={() => { window.location.href = 'https://www.app.deski.co/' }} />
                      </Box>


              </Box>

       )


}

export default Header
